// Uploads open 14 days before the event date and close at the archive date.
const UPLOADS_OPEN_BEFORE_EVENT_MS = 14 * 24 * 60 * 60 * 1000;

export interface UploadWindow {
  isNotActiveYet: boolean;
  isArchived: boolean;
}

/**
 * The guest page's upload state from the event's dates. An event without a
 * date (bought, never activated) is not active yet. The upload routes and
 * prepare_guest_upload enforce the same rules on every new file.
 */
export function getUploadWindow(
  {
    activatesAt,
    archivesAt,
  }: { activatesAt?: string | null; archivesAt?: string | null },
  now: Date = new Date()
): UploadWindow {
  const activatesAtMs = activatesAt ? new Date(activatesAt).getTime() : NaN;
  const isNotActiveYet =
    !Number.isFinite(activatesAtMs) ||
    activatesAtMs - UPLOADS_OPEN_BEFORE_EVENT_MS > now.getTime();
  const isArchived = archivesAt ? new Date(archivesAt) < now : false;
  return { isNotActiveYet, isArchived };
}
